import PropTypes from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

function SettingsTabs({ selectedTab }) {
  const history = useHistory();
  const permissions = useSelector((state) => state.permissionsReducer);
  return (
    <Tabs
      defaultActiveKey={selectedTab.toLowerCase().replace(' ', '-')}
      className="mb-4"
      onSelect={(nextTab) =>
        history.push(`/settings/${nextTab}`, { from: 'HomePage' })
      }
    >
      {permissions && permissions.includes('configuration_manage') && (
        <Tab eventKey="general" title="General" />
      )}
      <Tab eventKey="profile" title="Profile" />
      <Tab eventKey="password" title="Password" />
      {permissions && permissions.includes('billing_invoice_view') && (
        <Tab eventKey="billing" title="Billing" />
      )}
      <Tab eventKey="teams" title="Teams" />

      {permissions && permissions.includes('email_summaries_manage') && (
        <Tab eventKey="email-summaries" title="Email summaries" />
      )}
      {permissions && permissions.includes('integration_manage') && (
        <Tab eventKey="integration-status" title="Integrations" />
      )}
    </Tabs>
  );
}
SettingsTabs.propTypes = {
  selectedTab: PropTypes.string,
};
export default SettingsTabs;
